import config from "@/config"
import { getCommonParam } from "@/plugins/env"

export const getConfig = key => {
  const { dmTenantId } = getCommonParam()
  // 根据 dmTenantId 查找对应的配置项
  const configForTenant = config[dmTenantId] || {}
  return key ? configForTenant[key] : configForTenant
}

export default function (context, inject) {
  const appConfig = getConfig()
  inject("appConfig", appConfig)
}
